export const production = {
  API: {
    baseURL: 'https://backlinks.rankify.co.il/api',
  },
};
